import { render, staticRenderFns } from "./NewsListCustom.vue?vue&type=template&id=d2d1adb8&"
import script from "./NewsListCustom.vue?vue&type=script&lang=js&"
export * from "./NewsListCustom.vue?vue&type=script&lang=js&"
import style0 from "./NewsListCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports